import { NavLink } from 'react-router-dom';

import './styles/section-tabs.css';

// Barra de pestañas para agrupar recursos afines bajo una misma sección del menú.
// Semen vive como pestaña de Animales; Fincas como pestaña de Clientes. Cada pestaña
// es un NavLink a la lista del recurso (las rutas de detalle/stats siguen intactas).
// Las configs de pestañas viven en ./tabs.js.

export default function SectionTabs({ tabs }) {
    return (
        <nav className="section-tabs" aria-label="Secciones">
            {tabs.map((t) => (
                <NavLink
                    key={t.to}
                    to={t.to}
                    end
                    className={({ isActive }) => `section-tab ${isActive ? 'section-tab--active' : ''}`}
                >
                    {t.label}
                </NavLink>
            ))}
        </nav>
    );
}
